import { PaginationType } from "../../../../../services/types";
import { NumberedPageState } from "./types";

// `totalRows` is an upper bound, so this is the most a page can hold, not what it will.
export const expectedPageRows = ({
  page,
  limit,
  totalRows,
}: PaginationType): number =>
  Math.min(Math.max(totalRows - (page - 1) * limit, 0), limit);

// Never below the current page: a page past a shrunken count still has to be drawn to step back from.
export const numberedPageCount = ({
  page,
  limit,
  totalRows,
}: PaginationType): number => Math.max(1, Math.ceil(totalRows / limit), page);

export const numberedPageState = (
  pagination: PaginationType,
  entryCount: number,
): NumberedPageState => {
  if (pagination.totalRows === 0 && entryCount === 0) {
    return "empty";
  }
  const expected = expectedPageRows(pagination);
  if (entryCount === 0) {
    return expected > 0 ? "unavailable" : "pastEnd";
  }
  return entryCount < expected ? "short" : "complete";
};

export const activityEntriesText = (count: number): string =>
  count === 1 ? "1 entry" : `${count} entries`;

export const numberedPageSummary = (
  { page, limit, totalRows }: PaginationType,
  rowCount: number,
): string => {
  if (rowCount === 0) {
    return `Showing 0 of ${activityEntriesText(totalRows)}`;
  }
  const from = (page - 1) * limit + 1;
  return `Showing ${from}–${from + rowCount - 1} of ${activityEntriesText(totalRows)}`;
};
